import { priceFormat } from 'apps/products/utils/priceFormat';
import { setMessage } from 'apps/notifications/actions/notifications';

export function getCouponsInfo(basket) {
  const couponsDetails = {};
  if (!basket || !basket.items) {
    return couponsDetails;
  }
  basket.items.forEach(item => {
    if (item.quantity > 0 && item.coupon) {
      couponsDetails[item.coupon.id] = {
        sku: item.sku,
        rewardAmount: item.coupon.rewardAmount,
      };
    }
  });
  return couponsDetails;
}

export const showCouponNotification = (params) => (dispatch) => {
  const { requestParams: { actionParams: { basket, getState } } } = params;
  if (!basket || !getState) {
    return;
  }

  const prevCoupons = getCouponsInfo(basket);
  const newCoupons = getCouponsInfo(getState().basket);

  Object.keys(newCoupons).forEach(couponId => {
    if (!prevCoupons[couponId]) {
      const { rewardAmount } = newCoupons[couponId];
      const amountString = priceFormat({ value: rewardAmount });
      dispatch(setMessage(
        `<div class="cou-notif">
          <span class="icon icon__coupon cou-notif__icon"/></span>
          <div class="cou-notif__wrapper">
            <b>Coupon applied</b><br/>
            ${amountString} deducted from the price shown.
          </div>
        </div>`
      ));
    }
  });
};
